// 桌面布局 DTO + folder id 工具(对齐 backend/app/schemas/desktop_layout.py)。
//
// 形态见 docs/specs/260508-folder-feature/design-codex.md §3.1。
// 后端在 PUT 请求中对 folderId 做严格 regex 校验,非法 id 直接 422 拒绝
// (不重写),所以前端创建文件夹时必须用 generateFolderId() 拿到合法 id。

/** 桌面 items[] 中的单 App 条目。 */
export interface DesktopAppItemDTO {
  type: 'app';
  appId: string;
}

/**
 * 桌面 items[] 中的文件夹引用条目;``folders[]`` 中有同 id 的完整结构。
 * ``folderId`` 必须匹配 ``FOLDER_ID_PATTERN``。
 */
export interface DesktopFolderItemDTO {
  type: 'folder';
  folderId: string;
  name: string;
}

export type DesktopItemDTO = DesktopAppItemDTO | DesktopFolderItemDTO;

/** ``folders[]`` 中的完整文件夹结构(成员顺序 = ``items``)。 */
export interface DesktopFolderDTO {
  id: string;
  name: string;
  items: string[];
}

/** GET / PUT / POST(reset) 响应 + PUT 请求体共用的形态(后端两个 DTO 同结构)。 */
export interface DesktopLayoutDTO {
  version: number;
  items: DesktopItemDTO[];
  folders: DesktopFolderDTO[];
}

// 严格匹配后端 FOLDER_ID_PATTERN (backend/app/schemas/app_configs.py)。
// 注意保持双方一致 —— 修改时同步两侧。
export const FOLDER_ID_PATTERN = /^folder-[a-f0-9]{8}$/;

/**
 * 生成 ``folder-<8 位小写 hex>``,匹配 ``FOLDER_ID_PATTERN``。
 *
 * 使用 ``crypto.getRandomValues`` 产生 4 字节随机,转 hex。
 * 不依赖 ``crypto.randomUUID``(老 Safari 不支持),也不依赖 Math.random
 * (熵不够,可能撞 id)。
 */
export function generateFolderId(): string {
  const bytes = new Uint8Array(4);
  // 兜底:某些测试环境(jsdom 早期版本)没有 globalThis.crypto。
  const c = (globalThis as { crypto?: Crypto }).crypto;
  if (c && typeof c.getRandomValues === 'function') {
    c.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  let hex = '';
  for (const b of bytes) {
    hex += b.toString(16).padStart(2, '0');
  }
  return `folder-${hex}`;
}
